import { render } from "./GuidesPage.vue?vue&type=template&id=f9cb51d0&scoped=true"
import script from "./GuidesPage.vue?vue&type=script&lang=js"
export * from "./GuidesPage.vue?vue&type=script&lang=js"

import "./GuidesPage.vue?vue&type=style&index=0&id=f9cb51d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9cb51d0"]])

export default __exports__